import { reqBsk, reqIdx, reqTre, reqWds } from "@documalis/_const/const";

export function addRequestParam(aRequests, aLabel, aDatapref, aId, aTypepref) {
    aRequests.push({
        label: aLabel,
        datapref: aDatapref,
        id: aId,
        typepref: aTypepref,
    });
}

export function updateRequestParam(aRequests, aDatapref, aId, aTypepref) {
    let wIndex = -1;
    wIndex = getIndex(aRequests, aTypepref);
    if (wIndex !== -1) {
        aRequests[wIndex].datapref = aDatapref;
        aRequests[wIndex].id = aId;
    }
    if (aTypepref === 4  || aTypepref === 45  ) {
        return setPref(aId, Number(aDatapref));
    } else {
        return setPref(aId, aDatapref);
    }
}

export function getIndex(aRequests, aTypepref) {
    let wIndex = -1;
    wIndex = aRequests.findIndex((item) => {
        return item.typepref === aTypepref;
    });
    return wIndex;
}

export function getLabelOfTypePref(aTypePref, aRequest) {
    return aRequest[getIndex(aRequest, aTypePref)].label;
}

export function setPref(aId, aDataPref) {
    return {
        id: aId,
        datapref: aDataPref,
    };
}

export function setInformations(aData) {
    if (aData.version) {
        return aData.version.version;
    } else {
        return '';
    }
}

export function getPageList(aTranslate) {
    let wPage = [];
    wPage.push({ label: aTranslate.instant('defpage'), value: 'defpage'} );
    wPage.push({ label: aTranslate.instant('Baskets'), value: reqBsk} );
    wPage.push({ label: aTranslate.instant('FullText'), value: reqWds} );
    wPage.push({ label: aTranslate.instant('Tree'), value: reqTre} );
    wPage.push({ label: aTranslate.instant('Index'), value: reqIdx} );
    return wPage;
}
